import { Companion_getInstance3qian17ldglkv as Companion_getInstance } from './PrimitiveRanges.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { Companion_instance114o4di7mmtan as Companion_instance } from './Progressions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../exceptions.mjs';
import { checkStepIsPositive70940ky00dt4 as checkStepIsPositive } from './Ranges.mjs';
import { nextInt2pxj3bzg1eemu as nextInt } from '../random/Random.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function until(_this__u8e3s4, to) {
  if (to <= -2147483648)
    return Companion_getInstance().o3_1;
  return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
}
function downTo(_this__u8e3s4, to) {
  return Companion_instance.p3(_this__u8e3s4, to, -1);
}
function coerceAtMost(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().n2('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceAtLeast(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceAtMost_0(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function step(_this__u8e3s4, step) {
  checkStepIsPositive(step > 0, step);
  return Companion_instance.p3(_this__u8e3s4.q3_1, _this__u8e3s4.r3_1, _this__u8e3s4.s3_1 > 0 ? step : -step | 0);
}
function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().n2('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceAtLeast_0(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function contains(_this__u8e3s4, value) {
  // Inline function 'kotlin.let' call
  var it = toIntExactOrNull(value);
  return !(it == null) ? _this__u8e3s4.t3(it) : false;
}
function random(_this__u8e3s4, random) {
  try {
    return nextInt(random, _this__u8e3s4);
  } catch ($p) {
    if ($p instanceof IllegalArgumentException()) {
      var e = $p;
      throw NoSuchElementException().a2(e.message);
    } else {
      throw $p;
    }
  }
}
function toIntExactOrNull(_this__u8e3s4) {
  return (-2147483648n <= _this__u8e3s4 ? _this__u8e3s4 <= 2147483647n : false) ? convertToInt(_this__u8e3s4) : null;
}
function coerceAtMost_1(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
//region block: exports
export {
  coerceAtLeast_0 as coerceAtLeast3qxv4gros2xti,
  coerceAtLeast as coerceAtLeast2bkz8m9ik7hep,
  coerceAtMost as coerceAtMostfyc3emgaderp,
  coerceAtMost_1 as coerceAtMostmgknbongtqt,
  coerceAtMost_0 as coerceAtMost322komnqp70ag,
  coerceIn_0 as coerceIn10f36k81le1mm,
  coerceIn as coerceIn302bduskdb54x,
  contains as contains2c50nlxg7en7o,
  downTo as downTo39qhfeycepm1j,
  random as random3bgrvtipfs9sh,
  step as step18s9qzr5xwxat,
  until as until1jbpn0z3f8lbg,
};
//endregion

//# sourceMappingURL=_Ranges.mjs.map
